<template>
  <div class="container">
    <div class="row">
      <!-- <div class="col-md-4"></div> -->
      <div
        class="col-sm-4 offset-sm-4"
        style="margin: 145px auto;border: 2px solid #07a7e14f;"
      >
        <div class="form-group" style="text-align: center;margin-top: -105px;">
          <img :src="basepath+'/unodc_logo.png'" alt width="160" />
          <h4 class="text-center text-secondary">Forgot your password ?</h4>
        </div>
        <div style="text-align:left !important;">
          <div class="form-group">
            <div class="floating-label">
              <input
                class="floating-input form-control"
                v-model="email"
                type="email"
                placeholder=" "
              />

              <span
                class="lbl-label"
                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
              >
                <i class="material-icons" style="font-size: 20px;"
                  >account_circle</i
                >
              </span>
              <label class="lbl-label">someone@example.com</label>
            </div>
          </div>

          <div class="form-group" style="text-align: center;">
            <button
              type="submit"
              style="background-color: #07a7e1c2;border:1px solid #07a7e1c2;width: 100%"
              class="btn btn-primary"
              @click="forgotPassword"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
    data: () => ({
        email: "",
        basepath: localStorage.getItem("BASE_PATH")
    }),
    mounted() {
        // Set the initial number of items
    },
    components: {},
    methods: {
        forgotPassword() {
            this.inValid = [];
            if (!this.email) {
                this.inValid.push("Please enter your email.");
            }
            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                let self = this;
                this.openLoading();
                axios
                    .post(localStorage.getItem("BASE_PATH") + "/users/forgot-password", {
                        email: this.email,
                    })
                    .then(response => {
                        this.closeLoading();
                        if (response.status === 200 && response.data.message) {
                            self.toastSuccess(response.data.message);
                            setTimeout(() => {
                                this.$router.push("/");
                            }, 2000);
                        } else if (response.data.error) {
                            self.toastError(response.data.error);
                        }
                    })
                    .catch(error => {
                        this.closeLoading();
                        if (error.response && error.response.status === 404) {
                            self.toastError("Email not found");
                        } else {
                            self.toastError(error.message || "An unexpected error occurred");
                        }
                    });

            }
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        }
    }
};
</script>

<style scoped>
/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
    position: relative;
    margin-bottom: 5px;
}

.floating-input,
.floating-select {
    font-size: 14px;
    padding: 4px 30px 4px 5px;
    display: block;
    width: 100%;
    height: 36px;
    box-shadow: none !important;
    /* background-color: transparent; */
    border: none;
    border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
    outline: none;
    border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
    color: #ccc;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 6px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.floating-input:focus~label.lbl-label,
.floating-input:not(:placeholder-shown)~label.lbl-label {
    background-color: #fff;
    /* background-color: #fff; */
    top: -12px;
    left: 10px;
    font-size: 14px;
    color: rgba(7, 167, 225, 0.61);
    padding: 0px 5px;
}

.floating-select:focus~llabel.lbl-label,
.floating-select:not([value=""]):valid~label.lbl-label {
    top: -18px;
    font-size: 14px;
    color: #5264ae;
}

/* active state */
.floating-input:focus~.bar:before,
.floating-input:focus~.bar:after,
.floating-select:focus~.bar:before,
.floating-select:focus~.bar:after {
    width: 50%;
}

*,
*:before,
*:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

/* highlighter */
.highlight {
    position: absolute;
    height: 50%;
    width: 100%;
    top: 15%;
    left: 0;
    pointer-events: none;
    opacity: 0.5;
}

/* active state */
.floating-input:focus~.highlight,
.floating-select:focus~.highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@-moz-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@media (max-width: 768px) {
    .login-button {
        width: 100% !important;
    }
}
</style>
